// extracted by mini-css-extract-plugin
export default {"container":"vaa-z","productName":"waa-z","price":"xaa-z","dimensions":"yaa-z"};